module.exports = __webpack_public_path__ + "img/Gold.991bfdaf.png";